import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { ValidationGroup } from 'modules/campaigns/components/Form/ValidationGroup';
import { useValidationSectionState } from 'modules/taboola-common-frontend-modules/validations/components/ValidationSection';
import styles from './sectionHeaderAndSubtitle.module.scss';

const classNameBuilder = classnames.bind(styles);

export const SectionHeaderAndSubtitle = ({
    headerIcon,
    headerText,
    iconClassName,
    headerTitleClassName,
    subtitleText,
}) => {
    const validationsState = useValidationSectionState();
    return (
        <div className={classNameBuilder('header-title', headerTitleClassName)}>
            {headerIcon && <div className={classNameBuilder('header-icon', iconClassName)}>{headerIcon}</div>}
            <div className={styles['inner']}>
                <div className={styles['title-text']}>{headerText}</div>
                <div className={styles['subtitle']}>{subtitleText}</div>
            </div>
            <ValidationGroup validationsState={validationsState} placement={TOOLTIP_POSITION.LEFT} />
        </div>
    );
};

SectionHeaderAndSubtitle.propTypes = {
    headerIcon: PropTypes.node,
    headerText: PropTypes.node,
    iconStyle: PropTypes.string,
};

export default SectionHeaderAndSubtitle;
